import { useParams } from "react-router-dom";
import FormularioFuturasTareas from "./FormularioFuturasTareas";
import { useEffect, useState } from "react";
import { FuturaTarea } from "../DTO/FuturaTarea";
import { useFuturasTareasStore } from "../store/futurasTareas";
import toast from "react-hot-toast";
import { globalApiError } from "../utils/generalApiError";
import LoadingModal from "../elementos/LoadingModal";

const EditarFuturaTarea = () => {
  const params = useParams();
  const id = params.id;
const [futuraTarea, setFuturaTarea] = useState<FuturaTarea | null>(null);
  const [loading, setLoading] = useState(true);
  const { findFuturaTareaById } = useFuturasTareasStore();

  useEffect(() => {
    const findById = async () => {
      try {
        if (id === undefined) {
          alert("El id de la tarea no puede estar vacio");
          return;
        } else {
          const response = await findFuturaTareaById(id);
          setFuturaTarea(response);
        }
      } catch (error) {
        toast.error(globalApiError(error));
      } finally {
        setLoading(false);
      }
    };
    findById();
  }, []);

  return (
    <div>
      <LoadingModal show={loading} message="Cargando tarea futura..." />
      <div className="container mt-4">
        <h1 className="text-center mb-4">Editar Nueva Tarea Futura</h1>
        <FormularioFuturasTareas id={id ? id : null} tarea={futuraTarea} />
      </div>
    </div>
  );
};

export default EditarFuturaTarea;
